export const MODULE_FEATURE_KEY = 'module';
